<template>
  <div class="wrap">
    <template>
      <answer-sheet-list
        :opt="answerSheetListOptions"
        :query-form="forms"
        :settle-type="1"
        :search-field="answerSheetListSearchFields"
      />
    </template>
  </div>
</template>
<script>
import answerSheetList from '../components/answer-sheet-list'
import { answerSheetListOptions } from './options'
import { answerSheetListSearchFields } from './search'
export default {
  components: { answerSheetList },
  data() {
    return {
      forms: {
        settleStatus: 0, //结算状态
        keyword: '' // 调查员/调查员ID/任务ID/答卷ID
      },
      answerSheetListOptions,
      answerSheetListSearchFields
    }
  },
  methods: {}
}
</script>
<style scoped lang="scss">
.wrap {
  width: 100%;

  ul {
    display: flex;
    margin-bottom: 20px;

    li {
      width: 101px;
      height: 36px;
      border-radius: 0px 4px 4px 0px;
      border: 1px solid rgba(220, 223, 230, 1);
      display: inline-flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(48, 49, 51, 1);
    }
  }
}

.active {
  background: rgba(230, 241, 252, 1);
  color: #1989fa !important;
}
</style>
